<template>
    <b-card>
        <b-form-group>
            <b-form-radio v-model="selected" :value="constMonthDay">
                <div class="form-inline">
                    {{ strOccurs1 }} &nbsp;
                    <b-form-input
                        id="input-day"
                        type="number"
                        step="1"
                        style="width: 20%"
                        :min="1"
                        :max="31"
                        v-model.number="localMaanddagen"
                        :disabled="!editAllowed"
                        @change="setChanged"
                    ></b-form-input>
                    &nbsp;{{ strOccurs2 }}
                    <b-form-input
                        id="input-intervalday"
                        type="number"
                        step="1"
                        style="width: 20%"
                        v-model.number="localInterval"
                        :disabled="!editAllowed"
                        @change="setChanged"
                    ></b-form-input>
                    &nbsp;{{ strOccurs3 }}
                </div>
            </b-form-radio>
            <b-form-radio v-model="selected" :value="constWeekDay">
                <div class="form-inline">
                    {{ strOccurs4 }} &nbsp;
                    <b-form-select
                        style="width: 20%"
                        v-model="localWeek"
                        :options="locallijstWeken"
                        :disabled="!editAllowed"
                        @change="setChanged"
                    >
                        <template #first>
                            <b-form-select-option value=""
                                >--
                                {{
                                    $t('com_selecteer', {
                                        ns: 'common'
                                    })
                                }}
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                    <b-form-select
                        style="width: 20%"
                        v-model="localDag"
                        :options="locallijstDagen"
                        :disabled="!editAllowed"
                        @change="setChanged"
                    >
                        <template #first>
                            <b-form-select-option value=""
                                >--
                                {{
                                    $t('com_selecteer', {
                                        ns: 'common'
                                    })
                                }}
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                    &nbsp;{{ strOccurs2 }}
                    <b-form-input
                        id="input-intervalweek"
                        type="number"
                        step="1"
                        style="width: 20%"
                        v-model.number="localInterval"
                        :disabled="!editAllowed"
                        @change="setChanged"
                    ></b-form-input>
                    &nbsp;{{ strOccurs3 }}
                </div></b-form-radio
            >
        </b-form-group>
    </b-card>
</template>

<script>
import { recurrencyHelper, RECURRENCY_ENUM } from '../../models/Recurrency';
export default {
    name: 'CardMonthly',
    data() {
        return {
            selected: 1,
            constWeekDay: 2,
            constMonthDay: 1,
            localInterval: 1,
            localDag: 1,
            localWeek: 1,
            localMaanddagen: 12,
            strOccurs1: this.$t('rec_occursdaymonth1', { ns: 'recurrency' }),
            strOccurs2: this.$t('rec_occursdaymonth2', { ns: 'recurrency' }),
            strOccurs3: this.$t('rec_occursdaymonth3', { ns: 'recurrency' }),
            strOccurs4: this.$t('rec_occursdaymonth4', { ns: 'recurrency' })
        };
    },
    components: {},
    props: {
        weken: {
            type: Array,
            default() {
                return [];
            }
        },
        dagen: {
            type: Array,
            default() {
                return [];
            }
        },
        maanddagen: {
            type: Array,
            default() {
                return [];
            }
        },
        interval: {
            type: Number,
            default: 1
        },
        editAllowed: {
            type: Boolean,
            default: true
        },
        isNew: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        locallijstWeken() {
            return recurrencyHelper.lijstWeken(this.$t);
        },
        locallijstDagen() {
            return recurrencyHelper.lijstDagen(this.$t);
        }
    },
    methods: {
        setChanged() {
            const maanddagen =
                this.selected == this.constMonthDay
                    ? this.localMaanddagen
                    : undefined;
            const o = {
                type: RECURRENCY_ENUM.Monthly,
                interval: this.localInterval,
                dagen: [this.localDag],
                weken: [this.localWeek],
                maanddagen: [maanddagen]
            };
            this.$emit('changed', o);
        }
    },
    mounted() {},
    async created() {
        this.localMaanddagen = this.maanddagen[0];
        this.localWeek = this.weken[0];
        this.localDag = this.dagen[0];
        this.localInterval = this.interval;
        this.selected = this.localMaanddagen ? this.constMonthDay : this.constWeekDay;
        if (this.isNew) {
            this.setChanged();
        }
    }
};
</script>

